<template>
  <div
    class="pt-10 md:pt-20 overflow-visible"
    :class="{ 'px-box-4': content.layout === 'boxed_66' }"
    :data-widget-title="content.optionalTitle?.text"
  >
    <SliceTitle
      class="title lg:text-center mb-8 md:mb-14 xl:mb-18"
      :value="content.optionalTitle"
    />
    <RelatedContentList
      v-if="content.layout === 'boxed_66'"
      :optional-cta="content.optionalCta"
      :articles="articles"
    />
    <RelatedContentGrid v-else :optional-cta="content.optionalCta" :articles="articles" />
  </div>
</template>

<script lang="ts" setup>
import type { GQLRelatedContentSlice } from './generated/related-content'
import RelatedContentGrid from './related-content-grid.vue'
import RelatedContentList from './related-content-list.vue'

const props = defineProps<{ content: GQLRelatedContentSlice }>()

const { siteUrl } = useRuntimeConfig().public

const articles = computed(() =>
  props.content.articleLinks
    .filter((page) => !hasInvalidPlaceholderValue(page.title))
    .map((item) => ({ ...item, link: join(siteUrl, item.link) })),
)
</script>
